import { getSiteConfig } from '@shared/config';
import { getScrollBehavior } from '@shared/utils';
import { useTranslations } from 'next-intl';
import { useEffect, useRef } from 'react';
import { Link } from '../../../../Link/Link';
import { useTransactionsContext } from '../TransactionsContext';

function OlderTransactionsSection() {
  const { namespace, scrollTarget, setScrollTarget } = useTransactionsContext();
  const t = useTranslations(namespace);
  const ref = useRef<HTMLDivElement | null>(null);
  const { ROUTES, MY_ACCOUNT_SETTINGS } = getSiteConfig();
  const { olderTransactionsContactHref } = MY_ACCOUNT_SETTINGS;

  useEffect(() => {
    if (scrollTarget === 'older') {
      ref.current?.scrollIntoView({ behavior: getScrollBehavior() });
      setScrollTarget(null);
    }
  }, [scrollTarget, setScrollTarget]);

  return (
    <div className="flex flex-col gap-2 p-6 items-center text-center" data-testid="older-transactions-section" ref={ref}>
      {olderTransactionsContactHref ? (
        <p data-testid="older-transactions-contact-message">
          {t.rich('older_transactions_contact_message', {
            email_link: chunks => (
              <Link href={olderTransactionsContactHref} data-testid="older-transactions-link">
                {chunks}
              </Link>
            ),
          })}
        </p>
      ) : (
        <>
          <p data-testid="older-transactions-help-message">{t('looking_for_older_transactions')}</p>
          <Link href={ROUTES.HELP_CENTRE.CHAT} data-testid="older-transactions-link">
            {t('get_help')}
          </Link>
        </>
      )}
    </div>
  );
}

export { OlderTransactionsSection };
